module.exports = __webpack_public_path__ + "static/person7-928b0cd3438f2ffdaf1d851295fcb02c.png";